package com.fireavert.yardi.common_data.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class YardiCommonDataGetResidentByUnitResponse(
    val units: List<FullPropertyWithUnits>
)

interface YardiCommonDataGetResidentByUnitInterface {
    val units: List<FullPropertyWithUnits>
}

/**
 * Represents a property grouping containing units with full resident info.
 */
interface FullPropertyWithUnits {
    val propertyId: String // The common property ID from the units within
    val units: List<GetResidentByUnitUnitInfo>
}

/**
 * Represents a single unit with all fields from the GetResidentsByUnit response XML.
 */
interface GetResidentByUnitUnitInfo {
    val propertyId: String // Also stored here for direct access if needed, though redundant if grouped
    val unitId: String
    val marketRent: Double // Assuming numeric is desired
    val unitSqFt: Double // Assuming numeric is desired
    val unitEconomicStatus: String
    val unitEconomicStatusDescription: String
    val unitType: String
    val unitTypeDescription: String
    val unitTypeRent: Double // Assuming numeric is desired
    val unitTypeSqFt: Double // Assuming numeric is desired
    val mitsUnitOccupancyStatus: String
    val mitsUnitLeasedStatus: String
    val residents: List<GetResidentByUnitResidentInfo> // List of residents in this unit
}

/**
 * Represents a single resident with all fields and attributes from the GetResidentsByUnit response XML.
 */
interface GetResidentByUnitResidentInfo {
    // Attributes
    val pCode: String
    val tCode: String
    // Elements
    val status: String
    val mitsCustomerInfo: String
    val firstName: String?
    val lastName: String?
    val currentRent: Double? // Assuming numeric is desired
    val leaseFromDate: String? // Keep dates as String unless specific parsing needed
    val leaseToDate: String? // Keep dates as String, nullable just in case
    val moveInDate: String?
    val moveOutDate: String?
    val noticeDate: String?// Keep dates as String
    val otherOccupants: List<OtherOccupant>
}
